var ShowDataInputModule = /** @class */ (function () {
    function ShowDataInputModule() {
    }
    return ShowDataInputModule;
}());
export { ShowDataInputModule };
